import { IconDispatcher } from "shared/Icons";
import { FlexAlignCenter } from "shared/ui-basics";
import styled, { css } from "styled-components/macro";

interface TaxonomyItemProps {
	text: string;
	color: string;
	backgroundColor: string;
	showDot?: boolean;
	isUnlinkable?: boolean;
}

export default function TaxonomyItem({ text, color, backgroundColor, showDot = false, isUnlinkable }: TaxonomyItemProps) {
	return (
		<Container background={backgroundColor} isShowPointer={isUnlinkable} showDot={showDot}>
			<FlexAlignCenter>
				{showDot && <Dot color={color} />}
				<Text color={color}>{text}</Text>
			</FlexAlignCenter>
			{isUnlinkable && (
				<IconContainer color={color}>
					<IconDispatcher type="x" />
				</IconContainer>
			)}
		</Container>
	);
}

interface DotProps {
	color?: string;
}

const Dot = styled.div<DotProps>`
	margin-right: 4px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${(props) => props.color};
`;

interface ContainerProps {
	background: string;
	isShowPointer: boolean;
	showDot: boolean;
}

const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 24px;
	width: fit-content;
	max-width: 100%;
	border-radius: 4px;
	padding: 8px;
	border: none;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	background-color: ${({ background }) => background};
	${({ isShowPointer }) =>
		isShowPointer &&
		css`
			cursor: pointer;
		`};
	${({ showDot }) =>
		showDot &&
		css`
			border-radius: 12px;
		`};
`;

const Text = styled.div<{ color: string }>`
	color: ${({ color }) => color};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const IconContainer = styled.div<{ color: string }>`
	margin-left: 4px;
	width: 12px;
	height: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		width: 12px;
		height: 12px;
	}
	path {
		fill: ${(props) => props.color};
	}
`;
